<template>
  <v-flex
    class="tcloud-comp"
    @mouseenter="hover=true"
    @mouseleave="hover=false" >
    <div class="toolbar-container">
      <v-toolbar height="46" flat class="comp-title" :class="{
          'elevation-2': !hover && !noAnimation,
          'elevation-6 hover': hover && !noAnimation,
        }">
        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
      </v-toolbar>
      <div>
        <slot name="toolbar-extra"></slot>
      </div>
    </div>
    <slot />
  </v-flex>
</template>

<script>
export default {
  name: 'comp-title',
  props: {
    noAnimation: Boolean,
  },
  data: () => ({
    hover: false,
  }),
};
</script>

<style lang="stylus" scoped>
.tcloud-comp
  margin-top 22px
.toolbar-container
  display flex
  justify-content space-between
.comp-title
  background-color var(--v-primary-base)
  color white
  display inline-block
  width unset
  left 5px
  border-radius 4px
  animation: hover-out .5s forwards
  max-width calc(100% - 90px)
.comp-extra
  background-color var(--v-primary-base)
  color white
  width unset
.hover
  animation: hover-in .5s forwards

@keyframes hover-in {
  /* You could think of as "step 1" */
  0% {
    transform translateY(10px)
    z-index 0
  }
  50% {
    transform translateY(-15px)
    z-index 1
  }
  100% {
    transform translateY(5px)
    z-index 2
  }
}

@keyframes hover-out {
  /* You could think of as "step 1" */
  0% {
    transform translateY(5px)
    z-index 2
  }
  50% {
    transform translateY(-15px)
    z-index 1
  }
  100% {
    transform translateY(10px)
    z-index 0
  }
}
</style>
